import React, { useState, useEffect } from 'react';

import { Typography, Divider } from '@mui/material'
import Grid from '@mui/material/Grid';
import { GetReferenceCurrencies } from '../service/ReferenceData';
import MDTextField from './custom/MDTextField';

function CurrencyItem(props) {
  const [currency, setCurrency] = useState(props.currency);
  const [summary, setSummary] = useState(props.summary);

  const [countries, setCountries] = useState([]);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');

  // constructor(props) {
  //   super(props);
  //   this.state = { activeStep: props.activeStep, type: props.type, currency: props.currency, summary: props.summary, countries: [], error:false, errorText:'' };
  // }
  useEffect(() => {
    setCurrency(props.currency)
  }, [props.currency])
  useEffect(() => {
    setSummary(props.summary)
  }, [props.summary])

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   // console.log('in curitem ' + JSON.stringify(nextProps.activeStep + ' ' + JSON.stringify(prevState.activeStep)))
  //   if(nextProps.activeStep === 0 && nextProps.type === prevState.type && nextProps.currency !== prevState.currency) {
  //     // console.log('in curitem1 ' + JSON.stringify(nextProps.type + ' ' + JSON.stringify(prevState.type)))
  //     return { activeStep: nextProps.activeStep, summary: nextProps.summary, currency: nextProps.currency }
  //   } else   
  //   if(nextProps.summary !== prevState.summary) {
  //     // console.log('in curitem2 ' + JSON.stringify(nextProps.activeStep + ' ' + JSON.stringify(prevState.activeStep)))
  //     return { activeStep: nextProps.activeStep, summary: nextProps.summary }
  //   } else 
  //   if(nextProps.currency.currencyName !== '' && nextProps.currency !== prevState.currency && nextProps.activeStep !== prevState.activeStep) {      
  //       return { activeStep: nextProps.activeStep, currency: nextProps.currency }      
  //   } else 
  //   // console.log('in curitem3 ' + JSON.stringify(nextProps.activeStep + ' ' + JSON.stringify(prevState.activeStep)))
  //     return { activeStep: nextProps.activeStep }
  // }

  const handleSelectChange = (name, selectedOption) => {
    // console.log(name + " handleSelectChange " + JSON.stringify(selectedOption))   
    let newCurrency;
    
    if (name === 'otherType') {
      newCurrency = {
        ...currency,
        otherType: selectedOption
      }
    } else {
      newCurrency = {
        ...currency,
        country: selectedOption,
        // otherType: selectedOption === null? '' : selectedOption.type,
        exchangeRate: selectedOption === null? '' : selectedOption.exchangeRate,
        currencyName: selectedOption === null? '' : selectedOption.currencyName,
        currencySymbol: selectedOption === null? '' : selectedOption.currencySymbol,
        currencyCode: selectedOption === null? '' : selectedOption.currencyCode,
        usdEquivalent: selectedOption === null? '' : currency.amount * selectedOption.exchangeRate
      };      
    }
    setCurrency(newCurrency)
    // this.setState({ currency: newCurrency });
    props.updateCurrency({...newCurrency, country: newCurrency.country}, props.index, props.type)
  }
  
  const handleChange = (propertyName, value) => {    
    if (propertyName === 'amount') {
      let currencyerror = true;
      let newCurrency = {
        ...currency,      
        amount: value,
        usdEquivalent: value >= 1? value * currency.exchangeRate : 0
      };

      let isnumberpattern = /^\d+$/
      if(newCurrency.amount !== null && newCurrency.amount !== undefined) {
        if (!(isnumberpattern.test(newCurrency.amount))) {
          setError(true)
          setErrorText('Please enter a numeric value')
          // this.setState({usdEquivalent: 0})
        } else if ((newCurrency.amount > 2147483647) || ((value * newCurrency.exchangeRate) > 2147483647)) {
          setError(true)
          setErrorText('Maximum allowed amount exceeded')
          // this.setState({usdEquivalent: 0})
          newCurrency = { ...newCurrency, usdEquivalent: 0}
          currencyerror = false
        } else {
          setError(false)
          setErrorText('')
          // this.setState({usdEquivalent: value * currency.exchangeRate})
          currencyerror = true
        }
    
      }
      setCurrency(newCurrency)   
      props.updateCurrency({...newCurrency, country: newCurrency.country}, currencyerror, props.type)
    }
  }

  const handleRemove = (id) => {
    props.updateCurrency('', props.index, props.type, 'DEL')
    props.onClick(id)
  }

  const filterCountries = (inputValue) => {
    if (countries.length === 0) {
      const newCountries = GetReferenceCurrencies()
      setCountries(newCountries)
    }    
    return countries.filter(i =>        
        i.countryDescription.toLowerCase().includes(inputValue.toLowerCase()) ||
        i.currencyName.toLowerCase().includes(inputValue.toLowerCase()) ||
        i.value.toLowerCase().includes(inputValue.toLowerCase()) ||
        (i.currencyCode !== undefined && i.currencyCode.toLowerCase().includes(inputValue.toLowerCase()))        
    );
  };
  
  const promiseOptions = inputValue =>      
    new Promise(resolve => {
      setTimeout(() => {
        resolve(filterCountries(inputValue));
      }, 1000);
  });

  const handleError = (propertyName, error) => {
    // No logic needed here.  The required check
    // is done in the Currencies class
  }
  
  return (   
    <Grid>        
      <Grid container sx={{ ml: 0.5, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-end' }}>        

          <Grid sx={{ width: 148, ml: '8px', display: { xs: 'none', sm: 'block' } }}>{currency.type !== undefined && <Typography sx={{ fontSize: 16 }} id="curtype">{currency.type.otherTypeDescription}</Typography>}</Grid>
          <Grid sx={{ width: { xs: 92, sm: 300 }, ml: '8px' }}>{currency.country !== undefined && <Typography sx={{ fontSize: 16 }} id="curcountry">{currency.country.label}</Typography>}</Grid>
                    
          <Grid sx={{ width: { xs: 64, sm: 148 }, ml: '8px' }}>
          <MDTextField name='amount'  value={(currency.amount).toLocaleString(undefined, { minimumfractiondigits: 2 })} 
              error = {error} errorText = {errorText} handleChange={handleChange} handleError={handleError}
              required={true} disabled={summary? true : false} currency={true} summary={summary} inputProps={{maxLength: 10, id:props.locator==='Review'?'amount'+props.locator:'amount'}} />
          </Grid>    

          <Grid sx={{ width: '114px', ml: '4px', display: { xs: 'none', sm: 'block' } }}><Typography sx={{ fontSize: 16 }} id="curexrate" align="center">{currency.exchangeRate}</Typography></Grid>
          <Grid sx={{ width: { xs: 42, sm: '114px' }, ml: '4px' }}>
            <Typography sx={{ fontSize: 16 }} id="curusdeqiv" align="right">
            {(currency.usdEquivalent).toLocaleString('en', { style: 'currency', currency: 'USD', useGrouping: true, maximumfractiondigits:0, minimumfractiondigits: 0 })}
            </Typography>
          </Grid>
          
          
      </Grid>
      <Divider sx={{ mt: '28px', backgroundColor: "#e2e2e2", height: '2px' }} variant="fullWidth" />
    
    </Grid>   
  );
}

export default CurrencyItem;